import { Route, Routes } from 'react-router-dom';

import { CanDangNhap, CanQuyen } from './lib/guard.js';
import { layRouteCuaModule } from './lib/modules.js';
import { KhongTimThayPage } from './modules/core/pages/LoiPages.js';
import { LoginPage } from './modules/core/pages/LoginPage.js';

export function App() {
  const routes = layRouteCuaModule();

  return (
    <Routes>
      <Route path="/dang-nhap" element={<LoginPage />} />

      {routes.map((r) => (
        <Route
          key={r.path}
          path={r.path}
          element={
            // Route công khai render thẳng, không dựng AppShell và không gọi
            // `/core/me`. Mặc định mọi route vẫn phải đăng nhập.
            r.congKhai ? (
              r.element
            ) : (
              <CanDangNhap>
                {r.permission ? (
                  <CanQuyen module={r.permission.module} level={r.permission.level}>
                    {r.element}
                  </CanQuyen>
                ) : (
                  r.element
                )}
              </CanDangNhap>
            )
          }
        />
      ))}

      <Route
        path="*"
        element={
          <CanDangNhap>
            <KhongTimThayPage />
          </CanDangNhap>
        }
      />
    </Routes>
  );
}
